import React from "react";
import RefundV2 from "../../LogV2/refund";

/** Refund sync is V2-only. */
const Refund: React.FC = () => <RefundV2 />;

export default Refund;
